import React,  { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import './App.css';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';

import styled from 'styled-components';
import ProcesControleKubus from './pages/ProcesControleKubus';
import ProcesControleVoorraad from './pages/ProcesControleVoorraad';
import ProcesControleExpeditie from './pages/ProcesControleExpeditie';
import ProcesControleOpenstaand from './pages/ProcesControleOpenstaand';
import ProcesControleOpgelost from './pages/ProcesControleOpgelost';
import ProcesControlePrestaties from './pages/ProcesControlePrestaties';
import BusinessRuleOverview from './pages/BusinessRuleOverview';
import BusinessRuleForm from './pages/BusinessRuleForm';
import 'bootstrap/dist/css/bootstrap.min.css';

import moment from 'moment';
import "moment/locale/nl";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCheck,
  faEye
} from "@fortawesome/free-solid-svg-icons";

moment.locale('nl');

library.add(
  faCheck,
  faEye
);

const Container = styled.div`
  padding: 1.5rem;
  padding-bottom: calc(1em + env(safe-area-inset-bottom));
`;

const queryClient = new QueryClient();

function App() {
  useEffect(() => {
    const token = window.location.search.substring(7);
      if(token && token.length > 0) {
        localStorage.setItem('access_token', token);
      }
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Container>
        <Router>
          <Routes>
            <Route path="/businessrules" element={<BusinessRuleOverview />} />
            <Route path="/createbusinessrule" element={<BusinessRuleForm />} />
            <Route path="/editbusinessrule/:businessRuleId" element={<BusinessRuleForm />} />
            <Route path="/controlekubus" element={<ProcesControleKubus />} />
            <Route path="/controlevoorraadbloemen" element={<ProcesControleVoorraad bloemOfPlanten={0} />} />
            <Route path="/controlevoorraadplanten" element={<ProcesControleVoorraad bloemOfPlanten={1} />} />
            <Route path="/controleexpeditie" element={<ProcesControleExpeditie />} />
            <Route path="/controleopenstaand" element={<ProcesControleOpenstaand />} />
            <Route path="/controleopgelost" element={<ProcesControleOpgelost />} />
            <Route path="/controleprestaties" element={<ProcesControlePrestaties />} />
            <Route path="/" element={<ProcesControleVoorraad bloemOfPlanten={0} />} />
          </Routes>
        </Router>
      </Container>
    </QueryClientProvider>
  );
}

export default App;
